module.exports = __webpack_public_path__ + "static/img/1_2_5.72f40729.jpg";